<script>
  export let title = '';
</script>

<svelte:head>
  <title>{title} | PokeDex by R+</title>
</svelte:head>
